import { ImageProps } from 'next/image'
import Link from 'next/link'
import { Card } from '@cerifi/ui/components/card'
import { Eyebrow } from '@cerifi/ui/components/eyebrow'

import { RichText } from '../../cms/helper-components/rich-text'
import { Currency } from '../currency'

interface Props {
  name: string
  description: any
  price: number
  path?: string | undefined
  categoryName: string
  imgProps?: Omit<ImageProps, 'src' | 'layout' | 'placeholder' | 'blurDataURL'>
}

export const ProductCard: React.FC<Props> = ({
  name,
  description,
  price,
  path,
  categoryName,
}) => {
  return (
    <Link
      href={`/products${String(path)}`}
      aria-label={name}
      data-testid="product-card"
      className="h-full max-w-[25rem]"
    >
      <Card className="hover:bg-tan-50 h-full group flex flex-col transition-colors ease-in-out">
        <span className="text-xs tracking-wider font-medium uppercase text-neutral-700">
          {categoryName}
        </span>
        <p className="py-4 lg:text-xl font-medium tracking-wide text-neutral-900 leading-[120%]">
          {name}
        </p>
        <Eyebrow />

        <RichText
          className="line-clamp-4 pt-4 text-sm text-neutral-800"
          json={description?.json}
        />

        <div className="pt-4 font-medium">
          <Currency dollars={price} />
        </div>
      </Card>
    </Link>
  )
}
